export default "__VITE_ASSET__KLYoRBf___"